"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filtered = void 0;
const is_defined_1 = require("../is-defined/is-defined");
/**
 * @summary Removes null and undefined values from an array.
 *
 * Removes `null` and `undefined` values from an array. If the array is `null` or `undefined`, returns an empty array.
 *
 * @param {Array} array
 * @returns {Array}
 *
 * @example
 * const cleaned = filtered(maybeDirtyArray);
 */
function filtered(array) {
    return array?.filter(is_defined_1.isDefined) ?? [];
}
exports.filtered = filtered;
